import React from 'react';
import { useLocation } from 'react-router-dom';
import styled from 'styled-components';

import { FlexBoxColumn, HorizontalDivider } from '@ecp/common/src/layouts/flex/styled';
import { Spacing } from '@ecp/common/src/layouts/Spacing';

import SkypassFooterTermsAndConditions from '@ecp/fo/sites/skypass/components/footer/SkypassFooterTermsAndConditions';
import SkypassFooterBusinessInfo from '@ecp/fo/sites/skypass/components/footer/SkypassFooterBusinessInfo';
import SkypassFooterNotice from '@ecp/fo/sites/skypass/components/footer/SkypassFooterNotice';
import SkypassFooterEventNotice from '@ecp/fo/sites/skypass/components/footer/SkypassFooterEventNotice';

export default function SkypassFooter() {
  const { pathname } = useLocation();
  // [WIP-33461] 대한항공 /event 페이지 여부 flag값
  const isEventPage = pathname.startsWith('/event');

  return (
    <Container>
      {/* 알아두세요 */}
      {/* 대한항공 footer 영역 /event 페이지면 SkypassFooterEventNotice 이외 페이지면 SkypassFooterNotice */}
      {isEventPage ? <SkypassFooterEventNotice /> : <SkypassFooterNotice />}
      <Spacing top={40} />
      <HorizontalDivider width={'100%'} />
      {/* 이용약관, 개인정보처리방침, 로그인 버튼 */}
      <SkypassFooterTermsAndConditions />
      <HorizontalDivider width={'100%'} />
      {/* 사업자정보 */}
      <SkypassFooterBusinessInfo />
      <Spacing top={20} />
    </Container>
  );
}

const Container = styled(FlexBoxColumn)`
  width: 100%;
  margin-top: 100px;
`;
